import type { CheckedState } from '@radix-ui/react-checkbox';
import type { JSX } from 'react';
import type { DropdownObjectItem } from '../../';
import { DropdownItem, useDropdownContext } from '../../';

export function DropdownCustomItems({
  className,
  children,
}: {
  className?: string;
  children: (item: DropdownObjectItem | string, isSelected: CheckedState, index: number) => JSX.Element;
}) {
  const { items, isItemSelected, getValue, getLabel } = useDropdownContext();

  return items.map((item: DropdownObjectItem | string, index) => {
    const itemKey = `${getLabel(item).toLocaleLowerCase().replace(/\s/g, '-')}-${getValue(item)}`;
    return (
      <DropdownItem className={className} isSelected={isItemSelected(item)} item={item} key={itemKey}>
        {children(item, isItemSelected(item), index)}
      </DropdownItem>
    );
  });
}
